webpackJsonp([35783957827783],{

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var index = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = index(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var index = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = index(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = index(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, index(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _hoot = __webpack_require__(608);
	
	var _hoot2 = _interopRequireDefault(_hoot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          justifyContent: 'center',
	          marginTop: '3rem'
	        }
	      },
	      _react2.default.createElement(
	        'svg',
	        {
	          style: {
	            height: '18vh',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement('use', { xlinkHref: '#' + _hoot2.default.id })
	      )
	    ),
	    _react2.default.createElement('hr', {
	      style: {
	        borderStyle: 'solid',
	        borderWidth: '0px',
	        borderColor: 'grey',
	        background: 'light-grey',
	        position: 'relative',
	        top: '-0.7vh'
	      }
	    }),
	    _react2.default.createElement(
	      'h1',
	      {
	        style: {
	          textAlign: 'center'
	        }
	      },
	      'Hi there ! My name is Samuel Abiassi, UX Designer and Web Developer'
	    ),
	    _react2.default.createElement('hr', {
	      style: {
	        borderStyle: 'solid',
	        borderWidth: '0px',
	        borderColor: 'light-grey',
	        background: 'light-grey',
	        marginTop: '2rem'
	      }
	    }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Looking for a Super-Owl?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you ended up here, it most certainly means you are looking for someone who knows a little things or two about web development or UX design.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then let me ask you something...'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'What if I told you that you could get both?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You don\'t want your end users to leave your application just because it isn\'t good enough, right?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Well... worry not, my friend! You\'ve met the perfect owl for the job!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'See, here is the home of a special kind of bird. Not only one that knows how to develop web applications using JAM Stack, Progressive Web Apps, Service Workers etc., but one that cares about how the final users are going to use them. From the look of it, to the whole experience.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Want to learn more about me?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then let me start by ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/about/' },
	        'introducing myself.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Interested in the tools and skills I use in development? ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/dev-stack/' },
	        'Might as well go here.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Is it the UX process that have picked your interest? Then, ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/ux-design/' },
	        'head right there!'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(170);
	var sprite = __webpack_require__(171);
	var symbol = new SpriteSymbol({
	  "id": "hoot",
	  "use": "hoot-usage",
	  "viewBox": "0 0 143.94 233.17",
	  "content": "<symbol viewBox=\"0 0 143.94 233.17\" id=\"hoot\"><defs><style>#hoot .cls-1{fill:#4a008f;}#hoot .cls-2{fill:#b55fe4;}#hoot .cls-3{fill:#8c12e4;}#hoot .cls-4{fill:#d0ba4b;}#hoot .cls-5{fill:#8b11e4;}#hoot .cls-6{fill:#461505;}#hoot .cls-7{fill:#e6d5a3;}#hoot .cls-8{fill:#c6a720;}#hoot .cls-9{fill:#dd8ee6;}#hoot .cls-10{fill:#ab52e3;}#hoot .cls-11{fill:#7c46a5;}#hoot .cls-12{fill:#7c479d;}#hoot .cls-13{fill:#75523d;}#hoot .cls-14{fill:#fdfce2;}#hoot .cls-15{fill:#54544b;}</style></defs><title>Hoot !</title><g id=\"hoot_Calque_2\" data-name=\"Calque 2\"><g id=\"hoot_Calque_1-2\" data-name=\"Calque 1\"><path class=\"cls-1\" d=\"M128.57,179.89c-1,2.48-1.91,5-3,7.45a97.84,97.84,0,0,1-6.27,11.86,88.83,88.83,0,0,1-8,11,62.53,62.53,0,0,1-14,12.36A15.79,15.79,0,0,0,96,219.44a2.6,2.6,0,0,0,.36-.24,59.79,59.79,0,0,0,6.73-7.41,71.76,71.76,0,0,0,7.85-13,74.48,74.48,0,0,0,3.79-9.94,89.68,89.68,0,0,0,3.58-23.26c.1-3.08,0-6.17-.2-9.25-.19-2.89-.48-5.75-.91-8.61a79.48,79.48,0,0,0-2.63-11.53,72.6,72.6,0,0,0-6.09-14.26,65.86,65.86,0,0,0-8.84-12.34A43.35,43.35,0,0,0,88.9,101a34.41,34.41,0,0,0-15-4.36,36.31,36.31,0,0,0-7.27.32A34.53,34.53,0,0,0,52,102.66a48.93,48.93,0,0,0-11.49,11.18A71,71,0,0,0,33,126.21a74.12,74.12,0,0,0-4.31,11.37,90.14,90.14,0,0,0-3.32,22.35c-.1,3.13,0,6.25.2,9.38.19,2.84.47,5.67.9,8.49a81.1,81.1,0,0,0,2.74,11.89,71.66,71.66,0,0,0,7,15.65,67.36,67.36,0,0,0,7.28,10c1.15,1.3,2.44,2.47,3.61,3.74a10,10,0,0,0-1.32,2.76,53.25,53.25,0,0,1-6.2-4.76A71.44,71.44,0,0,1,33,210.41,89.68,89.68,0,0,1,24.12,198a94.34,94.34,0,0,1-8-16.73c-.12-.35-.31-.67-.47-1a1.53,1.53,0,0,0-.18-.73c-.95-2.74-1.77-5.52-2.49-8.32a126.09,126.09,0,0,1-3.65-29.62c0-2.64.08-5.28.19-7.93a123.52,123.52,0,0,1,1.54-14.8,108.26,108.26,0,0,1,5-19.24,30.94,30.94,0,0,0,1.24-3.45h0a.2.2,0,0,0,.12-.26A23.61,23.61,0,0,0,18.8,93c1.1-2.4,2.27-4.77,3.55-7.08.22-.4.16-.58-.2-.86A50.63,50.63,0,0,1,10.29,73,35.25,35.25,0,0,1,4.48,58.32,37.89,37.89,0,0,1,4.35,48,34.72,34.72,0,0,1,8.63,35.1a1.64,1.64,0,0,0,.11-.36c.93-1.33,1.72-2.76,2.74-4a.54.54,0,0,0,.09-.48q-.15-.81-.29-1.62-.85-5-1.7-10c-.66-3.89-1.29-7.78-2-11.66-.21-1.22.48-1.86,1.63-1.44q4.91,1.8,9.81,3.63L31.6,13.85a1.1,1.1,0,0,0,1-.07c1.35-.66,2.71-1.29,4.07-1.93A81.08,81.08,0,0,1,49.23,7.63a86.5,86.5,0,0,1,9.46-1.75q4.8-.61,9.64-.78C70.21,5,72.09,5,74,5A94,94,0,0,1,96.31,8,80,80,0,0,1,108,12.16a2.93,2.93,0,0,0,.42.12l3.56,1.8c.23.12.42,0,.61-.07l10.59-4.06,9.53-3.66c1-.39,1.73.27,1.55,1.37q-.66,4.06-1.29,8.12-1,6.31-2,12.61c0,.2-.07.38.07.54,1,1.06,1.74,2.29,2.64,3.4.61,1.17,1.37,2.25,2,3.42a35.15,35.15,0,0,1,3.62,10.35,36.32,36.32,0,0,1,.6,7.42,35.92,35.92,0,0,1-7.32,21,52.74,52.74,0,0,1-10.75,10.56c-.32.24-.31.35-.13.68a90.65,90.65,0,0,1,4.65,9.62c.13.33.32.64.48,1,0,.11,0,.22.15.24h0a.63.63,0,0,0,.08.48,109.29,109.29,0,0,1,6.66,26.36,137.73,137.73,0,0,1,1.05,16.51q0,3.61-.16,7.23c-.16,3.15-.41,6.28-.77,9.41a114.37,114.37,0,0,1-3,15.86C130.17,174.94,129.35,177.41,128.57,179.89ZM74.74,66.1c.27.2.53.42.8.61a19.81,19.81,0,0,0,3.24,2.05q0,2,0,4c0,2.13,1.12,3.24,3.26,3.24h45.21c2.05,0,3.1-.93,3.32-2.95a5.94,5.94,0,0,0,0-.63q0-5.11,0-10.22a21,21,0,0,0,1.95-2.65,18.56,18.56,0,0,0-1.94-21.92q0-4.92,0-9.84a4.59,4.59,0,0,0-.22-1.69,3,3,0,0,0-3-1.89H83.23c-.49,0-1,0-1.46,0a2.9,2.9,0,0,0-3,3q0,1.9,0,3.81a.63.63,0,0,0-.18,0,33.88,33.88,0,0,0-6.27,4.71c-.27.27-.48.44-.82.07a22.68,22.68,0,0,0-3.19-2.8,20.79,20.79,0,0,0-3.71-2.4c0-1.18-.08-2.37,0-3.55a3,3,0,0,0-3.22-3.19q-22.66,0-45.32,0a3.07,3.07,0,0,0-3.23,3.19c.08,3.17,0,6.35,0,9.52-.46.08-.59.51-.84.81A18.55,18.55,0,0,0,7.57,51.76a18.25,18.25,0,0,0,3.6,9.06,5.13,5.13,0,0,0,1.68,1.84c0,3.38,0,6.77,0,10.15a2.81,2.81,0,0,0,2.92,2.92H61.67a2.81,2.81,0,0,0,2.92-2.93c0-1.4,0-2.79,0-4.19a1.65,1.65,0,0,0,.73-.33c1.23-.75,2.39-1.61,3.55-2.47L70.14,67a2.49,2.49,0,0,0,3.62,0Z\" /><path class=\"cls-2\" d=\"M17.33,96.21a30.94,30.94,0,0,1-1.24,3.45,108.26,108.26,0,0,0-5,19.24,123.52,123.52,0,0,0-1.54,14.8c-.11,2.64-.23,5.28-.19,7.93A126.09,126.09,0,0,0,13,171.25c.72,2.81,1.54,5.58,2.49,8.32a1.53,1.53,0,0,1,.18.73,32.82,32.82,0,0,1-3.51-4.13A58.24,58.24,0,0,1,1.31,152.33c-.43-2.1-.75-4.21-1-6.33A70.27,70.27,0,0,1,.09,135.5a57.3,57.3,0,0,1,1-8.3,60.3,60.3,0,0,1,3.59-12.14,58.73,58.73,0,0,1,5.69-10.44,61.81,61.81,0,0,1,5-6.39A17,17,0,0,1,17.33,96.21Z\" /><path class=\"cls-2\" d=\"M128.57,179.89c.78-2.48,1.59-4.95,2.25-7.47a114.37,114.37,0,0,0,3-15.86c.36-3.13.61-6.26.77-9.41q.19-3.61.16-7.23a137.73,137.73,0,0,0-1.05-16.51A109.29,109.29,0,0,0,127.05,97a.63.63,0,0,1-.08-.48,34.08,34.08,0,0,1,3.57,4,61,61,0,0,1,5.13,7.38,57.82,57.82,0,0,1,7.09,18.72,60.5,60.5,0,0,1,.85,6.16,64.36,64.36,0,0,1,.32,7.06,74,74,0,0,1-.69,8.85,60.5,60.5,0,0,1-3,12,57.4,57.4,0,0,1-7.88,14.64c-1,1.37-2.08,2.69-3.16,4C129,179.54,128.89,179.81,128.57,179.89Z\" /><path class=\"cls-3\" d=\"M36.62,11.85c-1.36.64-2.72,1.27-4.07,1.93a1.1,1.1,0,0,1-1,.07L19.07,9.18q-4.9-1.82-9.81-3.63C8.11,5.12,7.42,5.76,7.63,7c.66,3.88,1.3,7.77,2,11.66q.84,5,1.7,10,.14.81.29,1.62a.54.54,0,0,1-.09.48c-1,1.27-1.81,2.7-2.74,4L6.91,24Q6,19,5.18,13.92C4.7,11,4.22,8.16,3.73,5.28,3.55,4.18,3.37,3.08,3.16,2A1.59,1.59,0,0,1,3.56.36a1.54,1.54,0,0,1,1.7-.2q8.1,3,16.22,6L34.34,11C35.11,11.25,35.86,11.56,36.62,11.85Z\" /><path class=\"cls-3\" d=\"M133.66,32.32c-.91-1.11-1.66-2.34-2.64-3.4-.15-.16-.1-.34-.07-.54q1-6.31,2-12.61.64-4.06,1.29-8.12c.18-1.1-.54-1.75-1.55-1.37l-9.53,3.66L112.55,14c-.19.07-.38.18-.61.07l-3.56-1.8,8.94-3.39,18.53-7,.59-.22a1.44,1.44,0,0,1,2.05,1.6c-.15,1.14-.37,2.28-.56,3.41L136.72,14q-.74,4.47-1.48,8.94c-.4,2.42-.78,4.84-1.19,7.26A14,14,0,0,1,133.66,32.32Z\" /><path class=\"cls-4\" d=\"M96,219.44a15.79,15.79,0,0,1,1.27,3.11c0,1.22.32,2.41.22,3.64a11.41,11.41,0,0,1-1.5,5.45,2.58,2.58,0,0,1-2.44,1.5,2.08,2.08,0,0,1-1.36-.7c-.26-.27-.42-.33-.67,0a2.07,2.07,0,0,1-3.16,0c-.22-.25-.37-.32-.63,0-1,1.18-2.59.93-3.55-.36a10.68,10.68,0,0,1-1.49-3.5l-.2-1.15a16.52,16.52,0,0,1,.15-4.35,7.94,7.94,0,0,1,1.89-4.28,2.06,2.06,0,0,1,3.14-.07c.3.28.45.29.75,0a2,2,0,0,1,3,0c.33.31.49.28.8,0a2.05,2.05,0,0,1,3.09.07C95.57,219,95.76,219.21,96,219.44Zm-2.81,6.45a16.74,16.74,0,0,0-.13-2.47,9.4,9.4,0,0,0-1.44-3.94,2,2,0,0,0-1.61-1A2.2,2.2,0,0,0,88,220a12.21,12.21,0,0,0-1,8.65,6.51,6.51,0,0,0,1.77,3.64,1.51,1.51,0,0,0,2.12.12,4.57,4.57,0,0,0,1.35-1.81A11.3,11.3,0,0,0,93.17,225.9Zm-10.3-.34a11.54,11.54,0,0,0,.28,2.82,6.89,6.89,0,0,0,1.74,3.79,1.59,1.59,0,0,0,2.49,0,.57.57,0,0,0,.12-.82,7,7,0,0,1-.7-1.62,14.58,14.58,0,0,1-.52-5.36,11.58,11.58,0,0,1,1.28-4.58.43.43,0,0,0-.06-.61,1.87,1.87,0,0,0-1.33-.64c-1,0-1.54.71-2,1.45A11.25,11.25,0,0,0,82.86,225.55Zm14.1.17a10.22,10.22,0,0,0-1.51-6.16,2,2,0,0,0-2-1c-.69.09-1.31.85-1.05,1.32a10.91,10.91,0,0,1,1.26,4.66,12.35,12.35,0,0,1-1.37,7,.31.31,0,0,0,0,.34,1.73,1.73,0,0,0,2.14.71,3.84,3.84,0,0,0,1.69-2A10.9,10.9,0,0,0,97,225.72Z\" /><path class=\"cls-4\" d=\"M45.77,221.81A10,10,0,0,1,47.09,219c1.44-1.35,2.13-1.41,3.6-.22.34.27.44,0,.6-.15a2,2,0,0,1,3.05,0c.33.31.49.27.8,0a2.06,2.06,0,0,1,3.1.07,6,6,0,0,1,1.39,2.32,14.59,14.59,0,0,1,.7,6.06l-.17,1.18a11,11,0,0,1-1.44,3.6c-.85,1.22-2,1.6-3.09,1a2.52,2.52,0,0,0-1.79,0,2,2,0,0,1-2.4-.28,4.65,4.65,0,0,1-.44-.55c-.56.51-1,1-1.71,1.08a2.45,2.45,0,0,1-2.36-1.3A10.28,10.28,0,0,1,45.39,227,17.37,17.37,0,0,1,45.77,221.81Zm10.32,3.49a10.14,10.14,0,0,0-.28-2.58,8,8,0,0,0-1.45-3.41,1.78,1.78,0,0,0-2.61-.4,4,4,0,0,0-1.25,1.8,13.28,13.28,0,0,0-.62,7.82,6.55,6.55,0,0,0,1.84,3.75,1.51,1.51,0,0,0,2.12.09,3.67,3.67,0,0,0,.73-.79A11,11,0,0,0,56.09,225.3Zm3.8,0a8.52,8.52,0,0,0-.27-2.64A7,7,0,0,0,57.9,219a1.78,1.78,0,0,0-2.56,0,.5.5,0,0,0-.13.71A10.8,10.8,0,0,1,56.47,224a12.79,12.79,0,0,1-1.26,7.47c-.07.13-.16.22-.06.39a1.73,1.73,0,0,0,2.21.66,2.92,2.92,0,0,0,1-1A10.55,10.55,0,0,0,59.88,225.34Zm-14.12.23a12.29,12.29,0,0,0,.78,4.58,4.24,4.24,0,0,0,1.82,2.43,1.58,1.58,0,0,0,1.89-.4c.58-.48.11-.8-.07-1.18,0-.08-.06-.16-.09-.24a13.55,13.55,0,0,1-.91-6.61,11.06,11.06,0,0,1,1.28-4.38.46.46,0,0,0-.09-.66,1.82,1.82,0,0,0-2.93.28A10.9,10.9,0,0,0,45.76,225.57Z\" /><path class=\"cls-1\" d=\"M60.15,228.29l.17-1.18a36.85,36.85,0,0,0,17.35,1.39c1.63-.25,3.21-.71,4.8-1.11l.2,1.15a20.65,20.65,0,0,1-3.7.74,45.68,45.68,0,0,1-6.94.48A48.09,48.09,0,0,1,60.15,228.29Z\" /><path class=\"cls-2\" d=\"M127,96.56c-.15,0-.15-.12-.15-.24A.21.21,0,0,1,127,96.56Z\" /><path class=\"cls-2\" d=\"M17.46,95.94a.2.2,0,0,1-.12.26A.23.23,0,0,1,17.46,95.94Z\" /><path class=\"cls-5\" d=\"M82.48,227.39c-1.59.4-3.17.85-4.8,1.11a36.85,36.85,0,0,1-17.35-1.39,14.6,14.6,0,0,0-.7-6.06,6,6,0,0,0-1.39-2.32,2.06,2.06,0,0,0-3.1-.07c-.31.29-.47.33-.8,0a2,2,0,0,0-3.05,0c-.17.15-.26.43-.6.15-1.47-1.18-2.16-1.13-3.6.22-1.17-1.28-2.46-2.44-3.61-3.74a67.36,67.36,0,0,1-7.28-10,71.66,71.66,0,0,1-7-15.65,81.1,81.1,0,0,1-2.74-11.89c-.44-2.82-.71-5.64-.9-8.49-.21-3.13-.3-6.25-.2-9.38a90.14,90.14,0,0,1,3.32-22.35A74.12,74.12,0,0,1,33,126.21a71,71,0,0,1,7.53-12.38A48.93,48.93,0,0,1,52,102.66a34.53,34.53,0,0,1,14.62-5.72,36.31,36.31,0,0,1,7.27-.32,34.41,34.41,0,0,1,15,4.36,43.35,43.35,0,0,1,10.72,8.64,65.86,65.86,0,0,1,8.84,12.34,72.6,72.6,0,0,1,6.09,14.26,79.48,79.48,0,0,1,2.63,11.53c.43,2.86.72,5.73.91,8.61.2,3.08.29,6.17.2,9.25a89.68,89.68,0,0,1-3.58,23.26,74.48,74.48,0,0,1-3.79,9.94,71.76,71.76,0,0,1-7.85,13,59.79,59.79,0,0,1-6.73,7.41,2.6,2.6,0,0,1-.36.24c-.21-.24-.41-.49-.63-.71a2.05,2.05,0,0,0-3.09-.07c-.31.29-.47.32-.8,0a2,2,0,0,0-3,0c-.3.28-.46.27-.75,0a2.06,2.06,0,0,0-3.14.07A7.94,7.94,0,0,0,82.62,223,16.52,16.52,0,0,0,82.48,227.39ZM59.56,143H35.62c-.57,0-1.18-.05-1.53.54s0,1.13.32,1.64l.09.17c4.08,7,8,14.05,12.19,20.94,1,1.57,1.84,3.18,2.77,4.77,3.19,5.46,6.3,11,9.52,16.41,2.59,4.37,5.09,8.79,7.62,13.18L71,208.3a1,1,0,0,0,1.49.52,2,2,0,0,0,.67-.83c2.75-4.76,5.47-9.54,8.25-14.29,2.31-3.94,4.44-8,6.74-11.93,3.27-5.63,6.51-11.28,9.77-16.92l7.93-13.74q1.9-3.3,3.8-6.6a1,1,0,0,0-.38-1.52,1.92,1.92,0,0,0-1-.16c-8.25.08-16.5-.05-24.75.1C75.56,143.08,67.56,143,59.56,143Z\" /><path class=\"cls-6\" d=\"M130.61,62.19q0,5.11,0,10.22a5.94,5.94,0,0,1,0,.63c-.22,2-1.27,2.95-3.32,2.95H82.06c-2.14,0-3.25-1.11-3.26-3.24q0-2,0-4V62.22q0-2.87,0-5.75c0-.17,0-.35-.19-.42a6.92,6.92,0,1,0-13.78,0c-.21,0-.24.2-.24.38q0,2.64,0,5.29v6.9c0,1.4,0,2.79,0,4.19a2.81,2.81,0,0,1-2.92,2.93H15.79a2.81,2.81,0,0,1-2.92-2.92c0-3.38,0-6.77,0-10.15q0-13,0-26c0-3.17.07-6.35,0-9.52a3.07,3.07,0,0,1,3.23-3.19q22.66,0,45.32,0a3,3,0,0,1,3.22,3.19c-.07,1.18,0,2.37,0,3.55,0,.11,0,.21,0,.32q0,9.65,0,19.31c0,.08,0,.17.11.22a8.51,8.51,0,0,1,7-3.61,8.62,8.62,0,0,1,7.12,3.7c0-.33,0-.51,0-.69q0-5.46,0-10.92,0-4,0-7.94,0-1.9,0-3.81a2.9,2.9,0,0,1,3-3c.49,0,1,0,1.46,0h44.13a3,3,0,0,1,3,1.89,4.59,4.59,0,0,1,.22,1.69q0,4.92,0,9.84c0,.34-.07.67-.07,1q0,11.34,0,22.69C130.55,61.61,130.59,61.9,130.61,62.19Zm-2-35.93a.12.12,0,0,0-.06-.06v0h0a.1.1,0,0,0-.07-.05c0-.1-.1-.11-.19-.11l0,0c-.08-.12-.15-.09-.23,0l-.24-.13a1.67,1.67,0,0,0-.93-.1H82.48c-1.69,0-2.26.56-2.26,2.24q0,13.65,0,27.3c0,.22-.08.47.1.67l0,.13c-.09,1.52,0,3,0,4.58-.18.2-.1.45-.1.67q0,5.52,0,11c0,1.63.6,2.23,2.21,2.23h44.39c1.69,0,2.26-.57,2.26-2.24q0-22.19,0-44.39a1.25,1.25,0,0,0-.09-.74l0-.38a.17.17,0,0,0-.09-.21l0,0c0-.09,0-.16-.1-.19a.11.11,0,0,0-.05-.07v0ZM63,26.34l-.12-.15a1.65,1.65,0,0,0-1.44-.64H52.42c-.48,0-1,0-1.45,0H50.6c-1.92-.11-3.85,0-5.77,0-3.45,0-6.9,0-10.34,0a1.09,1.09,0,0,0-.19,0q-9.08,0-18.16,0c-1.32,0-1.69.42-1.7,1.73q0,10,0,20.07c0,8.36,0,16.72,0,25.09a1.62,1.62,0,0,0,1.11,1.76c.34.36.78.27,1.2.27H61.45a1.88,1.88,0,0,0,1.15-.25,2.2,2.2,0,0,0,1-2q0-16.1,0-32.2,0-6.16,0-12.32A1.58,1.58,0,0,0,63,26.34Z\" /><path class=\"cls-5\" d=\"M78.78,31q0,4,0,7.94,0,5.46,0,10.92c0,.18,0,.37,0,.69a8.62,8.62,0,0,0-7.12-3.7,8.51,8.51,0,0,0-7,3.61c-.15,0-.11-.14-.11-.22q0-9.65,0-19.31c0-.11,0-.21,0-.32a20.79,20.79,0,0,1,3.71,2.4,22.68,22.68,0,0,1,3.19,2.8c.34.37.55.2.82-.07a33.88,33.88,0,0,1,6.27-4.71A.63.63,0,0,1,78.78,31Z\" /><path class=\"cls-7\" d=\"M64.63,61.72q0-2.64,0-5.29c0-.19,0-.33.24-.38l1.45,0,12.33,0c.21.07.19.25.19.42q0,2.87,0,5.75-2.08,1.87-4,3.88l-1,.89a2.49,2.49,0,0,1-3.62,0l-1.25-1.16C67.51,64.41,66.08,63.06,64.63,61.72Z\" /><path class=\"cls-5\" d=\"M12.85,36.63q0,13,0,26a5.13,5.13,0,0,1-1.68-1.84,18.25,18.25,0,0,1-3.6-9.06A18.55,18.55,0,0,1,12,37.44C12.25,37.15,12.39,36.72,12.85,36.63Z\" /><path class=\"cls-5\" d=\"M130.61,62.19c0-.29-.07-.59-.07-.88q0-11.34,0-22.69c0-.34,0-.67.07-1a18.56,18.56,0,0,1,1.94,21.92A21,21,0,0,1,130.61,62.19Z\" /><path class=\"cls-3\" d=\"M64.63,61.72c1.45,1.34,2.89,2.69,4.27,4.1-1.16.86-2.32,1.72-3.55,2.47a1.65,1.65,0,0,1-.73.33Z\" /><path class=\"cls-3\" d=\"M74.74,66.1q2-2,4-3.88v6.54a19.81,19.81,0,0,1-3.24-2C75.27,66.51,75,66.3,74.74,66.1Z\" /><path class=\"cls-8\" d=\"M93.17,225.9a11.3,11.3,0,0,1-.9,4.67,4.57,4.57,0,0,1-1.35,1.81,1.51,1.51,0,0,1-2.12-.12A6.51,6.51,0,0,1,87,228.63,12.21,12.21,0,0,1,88,220a2.2,2.2,0,0,1,2-1.46,2,2,0,0,1,1.61,1A9.4,9.4,0,0,1,93,223.43,16.74,16.74,0,0,1,93.17,225.9Z\" /><path class=\"cls-8\" d=\"M82.86,225.55A11.25,11.25,0,0,1,84.2,220c.43-.74.93-1.48,2-1.45a1.87,1.87,0,0,1,1.33.64.43.43,0,0,1,.06.61,11.58,11.58,0,0,0-1.28,4.58,14.58,14.58,0,0,0,.52,5.36,7,7,0,0,0,.7,1.62.57.57,0,0,1-.12.82,1.59,1.59,0,0,1-2.49,0,6.89,6.89,0,0,1-1.74-3.79A11.54,11.54,0,0,1,82.86,225.55Z\" /><path class=\"cls-8\" d=\"M97,225.72a10.9,10.9,0,0,1-.9,4.87,3.84,3.84,0,0,1-1.69,2,1.73,1.73,0,0,1-2.14-.71.31.31,0,0,1,0-.34,12.35,12.35,0,0,0,1.37-7,10.91,10.91,0,0,0-1.26-4.66c-.25-.47.36-1.23,1.05-1.32a2,2,0,0,1,2,1A10.22,10.22,0,0,1,97,225.72Z\" /><path class=\"cls-8\" d=\"M56.09,225.3a11,11,0,0,1-1.52,6.29,3.67,3.67,0,0,1-.73.79,1.51,1.51,0,0,1-2.12-.09,6.55,6.55,0,0,1-1.84-3.75,13.28,13.28,0,0,1,.62-7.82,4,4,0,0,1,1.25-1.8,1.78,1.78,0,0,1,2.61.4,8,8,0,0,1,1.45,3.41A10.14,10.14,0,0,1,56.09,225.3Z\" /><path class=\"cls-8\" d=\"M59.88,225.34a10.55,10.55,0,0,1-1.5,6.22,2.92,2.92,0,0,1-1,1,1.73,1.73,0,0,1-2.21-.66c-.09-.17,0-.26.06-.39A12.79,12.79,0,0,0,56.47,224a10.8,10.8,0,0,0-1.26-4.27.5.5,0,0,1,.13-.71,1.78,1.78,0,0,1,2.56,0,7,7,0,0,1,1.72,3.67A8.52,8.52,0,0,1,59.88,225.34Z\" /><path class=\"cls-8\" d=\"M45.76,225.57a10.9,10.9,0,0,1,1.68-6.17,1.82,1.82,0,0,1,2.93-.28.46.46,0,0,1,.09.66,11.06,11.06,0,0,0-1.28,4.38,13.55,13.55,0,0,0,.91,6.61c0,.08.05.16.09.24.18.38.65.69.07,1.18a1.58,1.58,0,0,1-1.89.4,4.24,4.24,0,0,1-1.82-2.43A12.29,12.29,0,0,1,45.76,225.57Z\" /><path class=\"cls-9\" d=\"M59.56,143c8,0,16,.11,24,0,8.25-.15,16.5,0,24.75-.1a1.92,1.92,0,0,1,1,.16,1,1,0,0,1,.38,1.52q-1.89,3.3-3.8,6.6l-7.93,13.74c-3.25,5.64-6.49,11.29-9.77,16.92-2.29,3.95-4.43,8-6.74,11.93-2.78,4.74-5.5,9.52-8.25,14.29a2,2,0,0,1-.67.83A1,1,0,0,1,71,208.3l-4.44-7.7c-2.54-4.4-5-8.82-7.62-13.18C55.76,182,52.65,176.48,49.46,171c-.93-1.59-1.81-3.21-2.77-4.77-4.23-6.88-8.11-14-12.19-20.94l-.09-.17c-.33-.5-.68-1-.32-1.64s1-.54,1.53-.54Zm24.83,2.81c-.26.09-.3.29-.39.45L73.81,163.86c-.32.56-.3.57.41.57h20.2c.74,0,.75,0,.38-.66l-8-13.85ZM71.92,167.35c-.29.15-.35.38-.46.58l-2.19,3.79-7.74,13.41c-.41.71-.39.72.38.72H81.85c.2,0,.47.11.59-.1s-.11-.38-.21-.56l-8.31-14.4ZM48.8,164.28l.66,0H69.78c.34,0,.41-.09.23-.4-.57-1-1.12-1.94-1.68-2.91q-4.25-7.36-8.5-14.73c-.25-.44-.42-.48-.64,0,0,.09-.1.18-.16.28l-8.41,14.56C50,162.12,49.44,163.17,48.8,164.28Z\" /><path class=\"cls-10\" d=\"M80.35,56.06l0-.13c0-.25,0-.51,0-.76q0-11.33,0-22.66c0-.57,0-1.14,0-1.71a1,1,0,0,1,.61-1,40.43,40.43,0,0,1,6.44-2.47,34.83,34.83,0,0,1,10-1.51c3.21.07,6.43-.12,9.64.11l.63,0,.25.1a32.14,32.14,0,0,1,3.84.73A38.78,38.78,0,0,1,122,30.72a31.32,31.32,0,0,1,4.76,3.21L129,35.77q0,13.84,0,27.69a1.11,1.11,0,0,1-.43.87,35,35,0,0,1-9.2,6.1,43.12,43.12,0,0,1-16.54,3.79,50,50,0,0,1-10.28-.6A40.45,40.45,0,0,1,81,70a.83.83,0,0,1-.54-.87c0-2.84,0-5.67,0-8.51l4.69-4.55Zm4.53-6.34c-.28,10.67,9,19.74,19.64,19.75A19.74,19.74,0,0,0,104.6,30C93.68,30,84.59,39.22,84.88,49.72Z\" /><path class=\"cls-10\" d=\"M34.48,25.59c3.45,0,6.9,0,10.34,0,1.92,0,3.85-.06,5.77,0,0,.08.09.08.15,0H51c.05.22.23.2.4.22A42.77,42.77,0,0,1,56.45,27,48.76,48.76,0,0,1,63,29.66c0,.21,0,.42,0,.63q0,12.58,0,25.15c0,.21,0,.42,0,.63H58.93a3.77,3.77,0,0,0,.83.93,44.57,44.57,0,0,0,3.28,3l0,9.58c-.75.34-1.49.7-2.24,1a41.31,41.31,0,0,1-11,3.07,15.45,15.45,0,0,0-2.53.37l-.87,0h-.16q-3.79.17-7.59,0h-.9a4.26,4.26,0,0,0-1.6-.24,43.33,43.33,0,0,1-8.75-1.94A38.7,38.7,0,0,1,15.65,65.5a2.7,2.7,0,0,1-1.16-2.38q.08-13.62,0-27.23A2.15,2.15,0,0,1,15.43,34c.1-.08.21-.14.31-.22a37.47,37.47,0,0,1,14-7.12C31.31,26.26,32.92,26,34.48,25.59Zm4.43,44.07c10.86.27,20.54-9,20.58-20.44A20.78,20.78,0,0,0,39,28.58a20.78,20.78,0,0,0-20.64,20.5C18.31,60.68,28.08,69.94,38.91,69.67Z\" /><path class=\"cls-11\" d=\"M34.48,25.59c-1.56.43-3.16.67-4.73,1.09a37.47,37.47,0,0,0-14,7.12c-.1.08-.21.14-.31.22a2.15,2.15,0,0,0-.93,1.86q.06,13.62,0,27.23a2.7,2.7,0,0,0,1.16,2.38,38.7,38.7,0,0,0,11.78,6.43,43.33,43.33,0,0,0,8.75,1.94,4.26,4.26,0,0,1,1.6.24c-.22.18-.49.1-.73.1H15.54a1.62,1.62,0,0,1-1.11-1.76c0-8.36,0-16.72,0-25.09q0-10,0-20.07c0-1.31.38-1.73,1.7-1.73q9.08,0,18.16,0A1.09,1.09,0,0,1,34.48,25.59Z\" /><path class=\"cls-12\" d=\"M80.44,60.61c0,2.84,0,5.67,0,8.51A.83.83,0,0,0,81,70a40.45,40.45,0,0,0,11.55,3.62,50,50,0,0,0,10.28.6,43.12,43.12,0,0,0,16.54-3.79,35,35,0,0,0,9.2-6.1,1.11,1.11,0,0,0,.43-.87q0-13.84,0-27.69,0-4.28,0-8.56a1.25,1.25,0,0,1,.09.74q0,22.19,0,44.39c0,1.68-.57,2.24-2.26,2.24H82.43c-1.62,0-2.21-.6-2.21-2.23q0-5.52,0-11c0-.22-.08-.47.1-.67A.24.24,0,0,1,80.44,60.61Z\" /><path class=\"cls-5\" d=\"M78.61,56.05l-12.33,0-1.45,0a6.92,6.92,0,1,1,13.78,0Z\" /><path class=\"cls-11\" d=\"M129,27.21q0,4.28,0,8.56l-2.23-1.84A31.32,31.32,0,0,0,122,30.72a38.78,38.78,0,0,0-10.23-3.92,32.11,32.11,0,0,0-3.84-.73c.12-.4.46-.23.69-.23l19.14,0L128,26h.23l0,0,.19.11a.1.1,0,0,1,.07.05.09.09,0,0,0,.06.06.12.12,0,0,1,.06.06.09.09,0,0,0,.06.06.1.1,0,0,1,.05.07l.1.19,0,0,.09.21Z\" /><path class=\"cls-13\" d=\"M15.54,74.22H37c.24,0,.51.08.73-.1H38a.17.17,0,0,0,.28,0h.22a.09.09,0,0,0,.16,0q3.79.17,7.59,0a.09.09,0,0,0,.16,0l.87,0c.18.17.4.1.6.1H61.39c1,0,1.63-.47,1.65-1.35,0-1.08,0-2.15,0-3.23l0-9.58v-4c0-.21,0-.42,0-.63q0-12.58,0-25.15c0-.21,0-.42,0-.63q0-1.66,0-3.32a1.58,1.58,0,0,1,.51,1.42q0,6.16,0,12.32,0,16.1,0,32.2a2.2,2.2,0,0,1-1,2,1.88,1.88,0,0,1-1.15.25H16.74C16.32,74.49,15.88,74.58,15.54,74.22Z\" /><path class=\"cls-12\" d=\"M127.72,25.82l-19.14,0c-.24,0-.57-.17-.69.23l-.25-.1a.44.44,0,0,0-.63,0c-3.21-.23-6.43,0-9.64-.11a34.83,34.83,0,0,0-10,1.51A40.43,40.43,0,0,0,81,29.81a1,1,0,0,0-.61,1c0,.57,0,1.14,0,1.71q0,11.33,0,22.66c0,.25,0,.51,0,.76-.18-.2-.1-.44-.1-.67q0-13.65,0-27.3c0-1.68.57-2.24,2.26-2.24h44.32A1.67,1.67,0,0,1,127.72,25.82Z\" /><path class=\"cls-11\" d=\"M63,26.34q0,1.66,0,3.32A48.78,48.78,0,0,0,56.45,27a42.77,42.77,0,0,0-5.09-1.21c-.17,0-.35,0-.4-.22.48,0,1,0,1.45,0h9.07a1.65,1.65,0,0,1,1.44.64l.12.15Z\" /><path class=\"cls-7\" d=\"M80.44,60.61a.24.24,0,0,0-.12,0c0-1.53-.06-3.05,0-4.58h4.78Z\" /><path class=\"cls-12\" d=\"M128.42,26.08l-.19-.11C128.31,26,128.39,26,128.42,26.08Z\" /><path class=\"cls-12\" d=\"M128.19,26H128C128,25.87,128.12,25.84,128.19,26Z\" /><path class=\"cls-12\" d=\"M128.94,26.83l-.09-.21A.17.17,0,0,1,128.94,26.83Z\" /><path class=\"cls-12\" d=\"M128.83,26.58l-.1-.19C128.82,26.42,128.84,26.49,128.83,26.58Z\" /><path class=\"cls-13\" d=\"M63,26.34l-.12-.15Z\" /><path class=\"cls-12\" d=\"M128.55,26.19a.09.09,0,0,1-.06-.06h0Z\" /><path class=\"cls-11\" d=\"M50.74,25.6c-.05.08-.1.08-.15,0Z\" /><path class=\"cls-12\" d=\"M128.67,26.32a.09.09,0,0,1-.06-.06h0Z\" /><path class=\"cls-5\" d=\"M84.39,145.77l2.41,4.15,8,13.85c.37.64.35.66-.38.66H74.22c-.71,0-.73,0-.41-.57L84,146.22C84.09,146.07,84.13,145.86,84.39,145.77Z\" /><path class=\"cls-3\" d=\"M71.92,167.35l2,3.43,8.31,14.4c.1.18.32.35.21.56s-.39.1-.59.1H61.91c-.77,0-.79,0-.38-.72l7.74-13.41,2.19-3.79C71.57,167.74,71.64,167.5,71.92,167.35Z\" /><path class=\"cls-5\" d=\"M48.8,164.28c.64-1.11,1.22-2.16,1.82-3.19L59,146.53c.05-.09.11-.18.16-.28.23-.46.39-.42.64,0q4.23,7.37,8.5,14.73c.56,1,1.11,1.95,1.68,2.91.19.31.11.42-.23.4H49.46Z\" /><path class=\"cls-14\" d=\"M84.88,49.72C84.59,39.22,93.68,30,104.6,30a19.74,19.74,0,0,1-.07,39.49C93.9,69.46,84.6,60.39,84.88,49.72Zm4.45-4.37a16.56,16.56,0,0,0,0,9.25,16,16,0,1,0,24.3-17.77c-6.17-4.34-14.79-3.06-18.7.67a5.56,5.56,0,0,1,1.37,10.8C93.62,49.19,91.32,48.23,89.33,45.35Z\" /><path class=\"cls-11\" d=\"M107,25.94a.44.44,0,0,1,.63,0Z\" /><path class=\"cls-14\" d=\"M38.91,69.67c-10.83.27-20.6-9-20.56-20.58A20.78,20.78,0,0,1,39,28.58a20.78,20.78,0,0,1,20.5,20.65C59.45,60.68,49.77,69.94,38.91,69.67ZM23.28,46.58c-2,6.91,2.9,15.45,10.32,18a16,16,0,1,0,.26-30.26,14,14,0,0,0-5.44,3.18,5.72,5.72,0,0,1,4.63,4.54,5.39,5.39,0,0,1-2.66,5.73C27.76,49.26,25.37,48.71,23.28,46.58Z\" /><path class=\"cls-11\" d=\"M63,69.63c0,1.08,0,2.15,0,3.23,0,.87-.62,1.35-1.65,1.35H47.9c-.2,0-.43.06-.6-.1a15.45,15.45,0,0,1,2.53-.37,41.31,41.31,0,0,0,11-3.07C61.53,70.33,62.27,70,63,69.63Z\" /><path class=\"cls-7\" d=\"M63,56.08v4a44.47,44.47,0,0,1-3.28-3,3.77,3.77,0,0,1-.83-.93Z\" /><path class=\"cls-11\" d=\"M38.3,74.12a.17.17,0,0,1-.28,0Z\" /><path class=\"cls-11\" d=\"M38.68,74.12a.09.09,0,0,1-.16,0Z\" /><path class=\"cls-11\" d=\"M46.43,74.12a.09.09,0,0,1-.16,0Z\" /><path class=\"cls-15\" d=\"M89.33,45.35c2,2.88,4.29,3.84,6.94,2.95a5.56,5.56,0,0,0-1.37-10.8c3.91-3.72,12.53-5,18.7-.67A16,16,0,1,1,89.3,54.6,16.56,16.56,0,0,1,89.33,45.35Z\" /><path class=\"cls-15\" d=\"M23.28,46.58c2.08,2.13,4.48,2.68,7.12,1.24a5.39,5.39,0,0,0,2.66-5.73,5.72,5.72,0,0,0-4.63-4.54,14,14,0,0,1,5.44-3.18,16,16,0,1,1-.26,30.26C26.18,62,21.28,53.49,23.28,46.58Z\" /></g></g></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8bbced0bf547c74ec6db.js